import axios from 'axios';

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('error api client axios', error);
    
    // Check if the error is due to an expired token
    if (error.response && error.response.status === 401 && error.response.data.message === 'Json Web Token is Expired, Try again' || error.response.data.message === 'Json Web Token is Expired, Try again ') {
      // Redirect to the home page
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default apiClient;